import { useQuery } from '@tanstack/react-query'
import api from '@/lib/api'
import { useAccessToken } from '@/features/auth/state/auth'
import { EditSuggestion } from '../components/SuggestionsPanel'

export function useFetchHistoryAgreementById(agreementId: string | undefined) {
  const token = useAccessToken()

  return useQuery<EditSuggestion[]>({
    // queryKey único por contrato (e por token se quiser isolar por sessão)
    queryKey: ['agreement-edit', agreementId, token],
    queryFn: async () => {
      const { data } = await api.get(`/agreement-edit/history/${agreementId}`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      // ajuste conforme sua API
      console.log(data.data)
      if (data?.data) return data.data as EditSuggestion[]
      throw new Error('Estrutura de resposta inesperada')
    },
    enabled: !!agreementId && !!token,
    placeholderData: [],
    staleTime: 30_000,
    refetchOnWindowFocus: false
  })
}
